/**
 * Created by Andste on 2018/5/3.
 */

import Cookies from "js-cookie";

const HASH_TOKEN_KEY = "_tk_";

function isLocalEnv() {
    const hostname = window.location.hostname;
    return (
        hostname === "localhost" ||
        /^\d+\.\d+\.\d+\.\d+$/.test(hostname)
    );
}

function getCookieDomain() {
    if (isLocalEnv()) return undefined;
    const parts = window.location.hostname.split(".");
    if (parts.length >= 2) {
        return "." + parts.slice(-2).join(".");
    }
    return undefined;
}

export default {
    setItem: (key, value, options = {}) => {
        const domain = getCookieDomain();
        if (domain) {
            options = { domain, ...options };
        }
        Cookies.set(key, value, options);
    },
    getItem: (key) => {
        return Cookies.get(key);
    },
    removeItem: (key, options = {}) => {
        const domain = getCookieDomain();
        if (domain) {
            options = { domain, ...options };
        }
        Cookies.remove(key, options);
    },

    getToken() {
        let token = this.getItem("token") || this.getItem("jwt");
        if (!token) {
            token = this.getHashToken();
            if (token) {
                this.setItem("token", token);
                this.setItem("jwt", token);
            }
        }
        this.clearHashToken();
        return token;
    },

    getHashToken() {
        var hash = window.location.hash;
        var reg = new RegExp(HASH_TOKEN_KEY + "([^&]*)");
        var match = hash.match(reg);
        if (match) {
            return decodeURIComponent(match[1]);
        }
        return null;
    },

    clearHashToken() {
        var hash = window.location.hash;
        var reg = new RegExp("[&]?" + HASH_TOKEN_KEY + "[^&]*", "g");
        var newHash = hash.replace(reg, "");
        if (newHash !== hash) {
            var url = window.location.href.replace(hash, newHash || "");
            window.history.replaceState(null, "", url);
        }
    },

    buildUrlWithToken(baseUrl, token) {
        if (!token) return baseUrl;
        var hashPart = "#" + HASH_TOKEN_KEY + encodeURIComponent(token);
        if (baseUrl.indexOf("#") !== -1) {
            return baseUrl + "&" + hashPart.substring(1);
        }
        return baseUrl + hashPart;
    },
};
